// extracted by mini-css-extract-plugin
module.exports = {"widget":"QuickBookingArticleC_widget__hlaP2","selectors":"QuickBookingArticleC_selectors__zHto5","rest-title":"QuickBookingArticleC_rest-title__qYmxH"};